import React from 'react'
import "./drop.css"
import DropProps from "./DropProps"

function DropMain() {
   return (
    <div>
        <div className="drop-container">
        <ul>
            <li className='drop-links'> <DropProps title="Women's Fashion" /> </li>
            <li className='drop-links'> <DropProps title="Health & Beauty" /></li>
            <li className='drop-links'> <DropProps title="Men's Fashion" /></li>
            <li className='drop-links'> <DropProps title = "Watches, Bags, Jewellery" /></li>
            <li className='drop-links'> <DropProps title = "Electronic Devices" /></li>
            <li className='drop-links'> <DropProps title = "TV & Home Appliances" /></li>
            <li className='drop-links'> <DropProps title = "Electronic Accessories" /></li>
            <li className='drop-links'> <DropProps title = "Groceries & Pets "/></li>
            <li className='drop-links'> <DropProps title = "Babies & Toys " /></li>
            <li className='drop-links'> <DropProps title = "Home & Lifestyle" /></li>
            <li className='drop-links'> <DropProps title= "Sports & Outdoor" /></li>
            <li className='drop-links'> <DropProps title = "Motors, Tools & DIY" /></li>    
        </ul>
        </div>
    </div>
  )
}

export default DropMain